import { Tag } from '@components';
import { Card, CustomIcon, Modal, playIcon, Typography } from '@design-system';
import { News } from '@services';
import { formatAgo } from '@utils';
import { MdDoneAll, MdOutlineAccessTimeFilled } from 'react-icons/md';
import ReactPlayer from 'react-player';
import './NewsCard.scss';
import { useState } from 'react';

type NewsCardProps = {
    news: News;
    detailed?: boolean;
    callback?: () => void;
};

export const NewsCard: React.FC<NewsCardProps> = ({ news, callback, detailed = false }) => {
    const [toggleImage, setToggleImage] = useState<boolean>(false);

    return (
        <Card className={`news-card ${detailed ? 'detailed' : ''}`} onClick={() => callback?.()}>
            <div className={`news-image ${detailed ? 'detailed' : ''}`}>
                {news.type === '1' ? (
                    <img src={news.link} alt={news.title} onClick={() => detailed && setToggleImage(!toggleImage)} />
                ) : (
                    <ReactPlayer
                        url={news.link}
                        className={`video-player ${detailed ? 'detailed' : ''}`}
                        controls
                        light
                        playing={false}
                        playIcon={<CustomIcon src={playIcon} alt="play" />}
                        config={{
                            youtube: {
                                playerVars: {
                                    playsinline: 1
                                }
                            }
                        }}
                    />
                )}
                {news.tags.length > 0 && <Tag title={news.tags[0].title} color={news.tags[0].color} />}
            </div>
            <Typography intrinsic={detailed ? 'h2' : 'h4'} defaultSpacing className="news-title">
                {news.title}
            </Typography>
            {!detailed && (
                <Typography intrinsic="p" defaultSpacing color="marine">
                    {news.subtitle}
                </Typography>
            )}
            <div className={`news-date ${detailed ? 'detailed' : ''}`}>
                {!detailed && news.seen && (
                    <Typography intrinsic="p" icon={<MdDoneAll />} iconPosition="left" className="news-read-mark">
                        Lu
                    </Typography>
                )}
                <Typography intrinsic="p" icon={<MdOutlineAccessTimeFilled />} iconPosition="left">
                    {formatAgo(news.date_create)}
                </Typography>
            </div>

            {detailed && <div className="news-content" dangerouslySetInnerHTML={{ __html: news.content }}></div>}

            <Modal title="Image de l'actualité" open={toggleImage} setClose={() => setToggleImage(false)}>
                <img src={news.link} alt={news.title} className="news-image-modal" />
            </Modal>
        </Card>
    );
};
